module.exports = "\n<div [@fadeAnimation]=\"prepareRoute(outlet)\" >\n  <router-outlet #outlet=\"outlet\"></router-outlet>\n</div>"